module.exports = __webpack_public_path__ + "static/media/new-logo-2.6b47322f.png";